<template>
  <div class="tags__wrapper-container">
    <p class="main__tags-title">
      Related domains
    </p>
    <div :class="['tags__wrapper', !getTagsList.length ? 'empty': '']">
      <div
        v-if="getTagsList"
        class="tags__list"
      >
        <tag-component
          v-for="tag of getTagsList"
          :key="tag.tagGuid"
          :tag="tag"
        />
      </div>
      <p v-if="!getTagsList.length">
        No data exist
      </p>
      <add-edit-tag-modal v-if="isModalOpened" />
    </div>
    <b-button @click="openAddEditTagModal(false)">
      Add new domain
    </b-button>
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '@/core/components/ContentSpinner.vue';
import AddEditTagModal from '@/modules/DataManagement/components/AddEditTagModal.vue';
import TagComponent from '@/modules/DataManagement/components/TagComponent.vue';

const {
  mapState: tagsMapState,
  mapActions: tagsMapActions,
} = createNamespacedHelpers('tags');

const {
  mapState: sidebarMapState,
} = createNamespacedHelpers('sidebar');
export default {
  name: 'TagsContainer',
  components: {
    TagComponent,
    AddEditTagModal,
    ContentSpinner,
  },
  data() {
    return {
      value: '',
      tableGuid: null,
    };
  },
  computed: {
    ...sidebarMapState({
      tablesList: state => state.tablesList,
    }),
    ...tagsMapState({
      isModalOpened: state => state.addEditTagModal.isOpen,
    }),
    getTagsList() {
      return this.tablesList[this.tableGuid].tags;
    },
  },
  methods: {
    ...tagsMapActions([
      'getAllTags',
      'addNewTag',
      'setAddEditTagModalState',
    ]),
    openAddEditTagModal(isEditMode) {
      this.setAddEditTagModalState({
        isOpen: true,
        data: null,
        isEditMode,
      });
    },
  },
  async beforeMount() {
    this.tableGuid = this.$route.params.tableUuid;
  },
};
</script>

<style scoped lang="scss">
.tags__wrapper-container,
.main__tags-title {
  margin-bottom: 0.5rem;
}

.tags__wrapper {
  max-height: 60px;
  border: 1px solid #cccccc;
  padding: 10px;
  border-radius: 6px;
  margin-bottom: 10px;

  &.empty {
    p {
      margin-bottom: 0;
      width: fit-content;
      font-size: 1.2em;
      color: #cccccc;
      margin-left: auto;
      margin-right: auto;
    }
  }
}

.tags__list {
  overflow-y: auto;
  white-space: nowrap;
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}
</style>